import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PageHeader, Result, Button, Spin } from 'antd';
import { MyBreadcrumb, accessControls } from 'utils';
import ScheduleForm from './form';

export default function ScheduleUpdate() {
  const history = useHistory();
  const { id } = useParams();
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    accessControls
      .fetch()
      .then(setPermissions)
      .catch(() => setPermissions({}));
  }, []);

  if (permissions == null) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!accessControls.can(permissions, 'Scheduling.update:any')) {
    return (
      <div style={{ padding: 24 }}>
        <Result
          status="403"
          title="Access denied"
          subTitle="You do not have permission to edit schedules."
          extra={
            <Button type="primary" onClick={() => history.push('/')}>
              Go to Dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Time Tracker', path: '/time-tracker/tracker' },
          { label: 'Schedules', path: '/time-tracker/scheduling' },
          { label: 'Edit', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => history.push('/time-tracker/scheduling')}
        title="Edit Schedule"
        subTitle="Update name, timezone, groups, and status"
      >
        <ScheduleForm id={id} />
      </PageHeader>
    </div>
  );
}
